export type FileType = "general" | "planning_summary";
export type FileTypeSettings = {
  id: string;
  label: string;
};

export const fileTypes: Record<FileType, FileTypeSettings> = {
  general: { id: "general", label: "General" },
  planning_summary: { id: "planning_summary", label: "Planning summary" },
};

export const EDITOR_FILE_EXTENSION = "landtech";

export const FILE_DEFAULT_NAME = "Untitled";
